module.exports = __webpack_public_path__ + "media/src/images/icons/alert-triangle-9281df7d4d8b6b56351bed5e1e416939.svg";